import * as types from './types'
import { getWindow, scrollToTop } from 'src/utils'
import { CLOSE_FRAME_ANIMATION_DURATION, MOBILE_BREAK } from 'src/utils/consts'

let requestDemoForm = null
let techniqueParentNode = null
let categoryParentNode = null

export const showForm = () => () => {
    if (!getWindow()) return
    const container = document.querySelector('.mkto-form-container')
    if (container) container.style.display = 'flex'
}

export const hideForm = () => () => {
    if (!getWindow()) return
    const container = document.querySelector('.mkto-form-container')
    if (container) container.style.display = 'none'
}

export const subscribeToResize = () => dispatch => {
    getWindow() && window.addEventListener('resize', () => dispatch(onResize()))
}

export const loadForm = () => dispatch => {
    if (!getWindow()) return
    if (process.env.GATSBY_SHOULD_LOAD_MKTO_SCRIPT === 'true') {
        window.MktoForms2.loadForm('//app-ab19.marketo.com', '280-XQP-994', 1372, marketoForm => {
            const contentNode = document.querySelector('.mkto-form-container .mkto-content')
            const form = marketoForm.getFormElem()[0]
            contentNode.appendChild(form)
            techniqueParentNode = contentNode
            categoryParentNode = contentNode
            requestDemoForm = form
        })
        return
    }
    const form = document.querySelector('#mktoForm_1372')
    if (!form) return setTimeout(() => dispatch(loadForm()), 100)
    const loader = form.querySelector('.loader')
    loader || (getWindow() && console.log('no loader'))
    loader && loader.remove()
    requestDemoForm = form
    techniqueParentNode = form.parentNode
    categoryParentNode = document.querySelector('.mkto-form-container .mkto-content')
}

export const useRequestDemoScrollBehavior = () => dispatch => {
    if (!getWindow()) return
    if (!requestDemoForm) return setTimeout(() => dispatch(useRequestDemoScrollBehavior()), 100)
    categoryParentNode.appendChild(requestDemoForm)
    const contactButton = document.querySelector('.go-contact')
    contactButton && contactButton.removeEventListener('click', scrollToTop)
    window.impactUseRequestDemoScrollBehavior && window.impactUseRequestDemoScrollBehavior()
}

export const useRequestDemoLightboxBehavior = () => dispatch => {
    if (!getWindow()) return
    if (!requestDemoForm) return setTimeout(() => dispatch(useRequestDemoLightboxBehavior()), 100)
    techniqueParentNode.appendChild(requestDemoForm)
    const contactButton = document.querySelector('.go-contact')
    contactButton && contactButton.addEventListener('click', scrollToTop)
    window.impactUseRequestDemoLightboxBehavior && window.impactUseRequestDemoLightboxBehavior()
}

export const onResize = () => dispatch => {
    if (!getWindow()) return
    dispatch(setWindowWidth(document.body.clientWidth))
    dispatch(setWindowHeight(window.innerHeight))
    dispatch(setIsDesktop(document.body.clientWidth > MOBILE_BREAK))
    dispatch(checkScrollBehavior())
}

export const setWindowWidth = value => dispatch => {
    dispatch({
        type: types.SET_WINDOW_WIDTH,
        payload: value,
    })
}

export const setIsDesktop = value => dispatch => {
    dispatch({
        type: types.SET_IS_DESKTOP,
        payload: value,
    })
}

export const setWindowHeight = value => dispatch => {
    dispatch({
        type: types.SET_WINDOW_HEIGHT,
        payload: value,
    })
}

export const setUseCases = value => dispatch => {
    dispatch({
        type: types.SET_USE_CASES,
        payload: value,
    })
}

export const setCurrentUseCase = value => dispatch => {
    dispatch({
        type: types.SET_CURRENT_USE_CASE,
        payload: value,
    })
}

export const setShouldShowUseCases = value => (dispatch, getState) => {
    dispatch({
        type: types.SET_SHOULD_SHOW_USE_CASES,
        payload: value,
    })

    const { isDesktop } = getState()

    if (value && !isDesktop) {
        dispatch(disableScrolling())
    }

    if (!value && !isDesktop) {
        dispatch(enableScrolling())
    }

    if (!value) {
        setTimeout(() => {
            dispatch(setCurrentUseCase(null))
        }, CLOSE_FRAME_ANIMATION_DURATION)
    }
}

export const checkScrollBehavior = () => (dispatch, getState) => {
    const { shouldShowUseCases, isDesktop } = getState()
    if (shouldShowUseCases && isDesktop) dispatch(enableScrolling())
    if (shouldShowUseCases && !isDesktop) dispatch(disableScrolling())
}

export const disableScrolling = () => () => {
    if (getWindow()) document.scrollingElement.style.overflowY = 'hidden'
}

export const enableScrolling = () => () => {
    if (getWindow()) document.scrollingElement.style.overflowY = 'auto'
}
